import { MODULE_NAME } from './constants';

export const SEARCH = `${MODULE_NAME}/SEARCH`;
export const ONE = `${MODULE_NAME}/ONE`;
export const DELETE = `${MODULE_NAME}/DELETE`;
export const GET_BOOKINGS_STATUS_OPTIONS = `${MODULE_NAME}/GET_BOOKINGS_STATUS_OPTIONS`;
export const STORE_BOOKINGS_STATUS_OPTIONS = `${MODULE_NAME}/STORE_BOOKINGS_STATUS_OPTIONS`;
export const GET_BOOKINGS_MOVEMENT_STATUS_OPTIONS = `${MODULE_NAME}/GET_BOOKINGS_MOVEMENT_STATUS_OPTIONS`;
export const STORE_BOOKINGS_MOVEMENT_STATUS_OPTIONS = `${MODULE_NAME}/STORE_BOOKINGS_MOVEMENT_STATUS_OPTIONS`;
